export enum OnboardingStatusEnum {
  CREATED = 'created',
  CREDIT_EVALUATION = 'credit-evaluation',
  REPRESENTATIVES_REGISTER = 'representatives-register',
  DOCUMENTS_VALIDATION = 'documents-validation',
  ACCOUNT_CREATED = 'account-created',
  ACCOUNT_DENIED = 'account-denied',
  ACCOUNT_FAILED = 'account-failed',
  CREDIT_REQUEST = 'credit-request',
  CREDIT_RELEASE = 'credit-release',
  DOCUMENTS_COLLECT = 'documents-collect',
  REPROVED = 'reproved',
  APPROVED = 'approved',
}
